import * as yup from 'yup'

const nullableString = yup.string().nullable()

export default {
    metaDescription: nullableString,
    metaTitle: nullableString,
    address2: nullableString,
    address3: nullableString,
    website: nullableString,
    specialOpeningHours: nullableString,
    generalInformation: nullableString,
    name: yup.string().required(),
    address1: yup.string().required(),
    city: yup.string().required(),
    county: yup.string().required(),
    postcode: yup.string().required(),
    country: yup.string().required(),
    locationStatus: yup.string().required(),
    latitude: yup.string().required(),
    longitude: yup.string().required(),
}
